/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OD260 to Nucleic Acid Concentration Calculator — Toolverse`)
};

const es_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de OD260 a Concentración de Ácido Nucleico — Toolverse`)
};

const de_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OD260-zu-Nukleinsäurekonzentration-Rechner — Toolverse`)
};

const nl_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OD260-naar-nucleïnezuurconcentratiecalculator — Toolverse`)
};

const fr_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur OD260 vers concentration d'acide nucléique — Toolverse`)
};

const it_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore da OD260 a concentrazione di acido nucleico — Toolverse`)
};

const pt_br2_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de OD260 para Concentração de Ácido Nucleico — Toolverse`)
};

const pt_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de OD260 para Concentração de Ácido Nucleico — Toolverse`)
};

const ja_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OD260から核酸濃度への計算ツール — Toolverse`)
};

const zh_od_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OD260 转核酸浓度计算器 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_meta_title", locale)
	if (locale === "en") return en_od_meta_title(inputs)
	if (locale === "es") return es_od_meta_title(inputs)
	if (locale === "de") return de_od_meta_title(inputs)
	if (locale === "nl") return nl_od_meta_title(inputs)
	if (locale === "fr") return fr_od_meta_title(inputs)
	if (locale === "it") return it_od_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_od_meta_title(inputs)
	if (locale === "pt") return pt_od_meta_title(inputs)
	if (locale === "ja") return ja_od_meta_title(inputs)
	return zh_od_meta_title(inputs)
};